function Button() {
    return <h2>Hi, I am a Button masalan!</h2>;
  }
  
  export default Button;
  